import { Box, Button, Chip, CircularProgress, Grid, Paper, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import moment from 'moment-timezone';
import MyTable from './MyTable';
import ApiService from '../../functions/apiService';
import AuthContext from '../../context/AuthContext';
import { varFormatTime } from '../../utils/helperFunctions';

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export default function DashboardMemberLog({ backFunction }) {
    const { permission, pages, pagesName, user } = useContext(AuthContext);
    const data = useSelector((state) => state.dashboardReducer.Data)
    const [rows, setRows] = useState();
    const [loading, setLoading] = useState(true);
    let groupName = Object.keys(pagesName).includes("GROUP_HEADER_TEXT")
        ? pagesName.GROUP_HEADER_TEXT
        : "Group";
    const columns = [
        {
            field: 'Overtime_List', headerName: 'Shift', flex: 1, minWidth: 350,
            valueGetter: (params) => 
							params.row.orig_emp ? 
							params.row.orig_emp?.employee_assignment?.EA_Rank + ' ' + 
							params.row.orig_emp?.First_name + ' ' + 
							params.row.orig_emp?.Last_name + ' , ' + params.row.AbsentText + ' , ' + 
							capitalizeFirstLetter(params.row.Overtime_List.toLowerCase())
							: 
							'Detail'  +  params.row.AbsentText + ' , ' + 
							capitalizeFirstLetter(params.row.Overtime_List.toLowerCase())
        },
        {
            field: 'StatusName', headerName: 'Status', flex: 1, minWidth: 120,
            filterable: false,
            renderCell: (params) => {
                if (params.row.StationName) {
                    return (
                        <Chip style={{ width: '120px', background: 'gray', color: '#fff' }} label={params.row.StationName} />
                    );
                }
            }
        },
        {
            field: 'CreatedBy', headerName: 'Created By', flex: 1, minWidth: 120,
            valueGetter: (params) => params.row.creating_emp?.First_name + ' ' + params.row.creating_emp?.Last_name
        },
        {
            field: 'Date', headerName: 'Date', flex: 1, minWidth: 250,
            valueGetter: (params) => varFormatTime(params.row.Create_Time, user?.Time_Format)
        },
        {
            field: 'ChangedBy', headerName: 'Changed By', flex: 1, minWidth: 120,
            renderCell: (params) => {
                if (params.row.changing_emp) {
                    return (
                        params.row.changing_emp?.First_name + ' ' + params.row.changing_emp?.Last_name
                    );
                }
            }
        },
    ];
    const columns2 = [
        {
            field: 'name', headerName: 'Members', flex: 1, minWidth: 140,
            valueGetter: (params) => 
							params.row.employee ?
							(params.row.employee?.employee_assignment?.EA_Rank ?? '') + ' ' + 
							params.row.employee?.First_name + ' ' + params.row.employee?.Last_name
							:
							'Detail'
        },
        {
            field: 'ResponseName', headerName: 'Response', flex: 1, minWidth: 120,
        },
        {
            field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 140,
            valueGetter: (params) => {
                if (params.row.over_time_shift.Shift_Code > 90) {
                    return params.row.over_time_shift.Start_Time + ' - ' + params.row.over_time_shift.End_Time
                } else if (params.row.over_time_shift.Detail_Type) {
                    return params.row.over_time_shift.Detail_Type + ': ' + params.row.over_time_shift.Detail_Text
                } else {
                    return params.row.over_time_shift.Overtime_List
                }
            }
        },
        {
            field: 'Hours', headerName: 'Hours', flex: 1, minWidth: 120,
            valueGetter: (params) => params.row.Hours
        },
        {
            field: 'offered', headerName: 'Action taken by', flex: 1, minWidth: 140,
            valueGetter: (params) => params.row.creating_emp.fullName
        },
        {
					field: 'Create_Time', headerName: 'Time', flex: 1, minWidth: 120,
					valueGetter: (params) => {
						let utcTime = moment(params.row.Create_Time).utc()
						let usTime = moment.tz(utcTime, "MM/DD/YYYY HH:mm:ss", "America/New_York").format('MM/DD/YYYY HH:mm:ss')
						return (
							// varFormatTime(usTime, user?.Time_Format)
							varFormatTime(params.row.Create_Time, user?.Time_Format)
						)
						}
        },
    ];

    useEffect(() => {
        ApiService.get('/dayAbsentLog?date=' + moment(data.date).format('DD-MM-YYYY'), {}, 'dayAbsentLog').then(({ data }) => {
            setRows(data)
            setLoading(false)
        }).catch(() => {
            setLoading(false)
        })
    }, [])

    return (
        <>
            <Paper className='p-4 my-3'>
                <Box>
                    <Button className=' text-decoration-none px-0' onClick={backFunction} style={{ color: '#555555' }}> <ArrowBackIosIcon /> Back</Button>
                </Box>
                <Typography variant="h5" className="mb-3">Daily Schedule Log: {moment(data.date).format("dddd Do MMMM YYYY")} - {groupName + ' ' + data.group["DAY"]}</Typography>
                {loading && (
                    <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
                        <CircularProgress />
                    </Box>
                )}
                {!loading && (
                    <div className='mb-4'>
                        <div>
                            <p className='bg-theme-orange  p-2'>Overtime Shifts</p>
                            {rows &&
                                <MyTable rows={rows.data} columns={columns} useTopFilter={false} hideFooter={true} checkboxSelection={false} ></MyTable>
                            }
                        </div>
                        <br />
                        <div>
                            <p className='bg-theme-orange  p-2'>Call Log</p>
                            {rows &&
                                <MyTable rows={rows.CallLog} columns={columns2} useTopFilter={false} hideFooter={true} checkboxSelection={false} ></MyTable>
                            }
                        </div>
                    </div>
                )}
            </Paper>
        </>)
}
